import withTranslation from "next-translate/withTranslation";
import { withRouter } from "next/router";
import { Component } from "react";
import { connect } from "react-redux";
import gs from "styles/Global.module.css";
import getRPCQfromCoords from "utils/getRPCQfromCoords";
import PlacesAutocomplete from "utils/PlacesAutocomplete/PlacesAutocomplete";
import styles from "../../LPBlocs.module.css";
import SelectItem from "./SelectItem";



class LPSearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actif: "estimer",
      activateGMAPS: false,
      recentSearches: [],
      displayRecentSuggestions: false,
      recentSuggestions: [],
      zoom: 5,
      speed: 2.5,
      handle_recherche: false,
      commune: null,
      province: null,
      region: null
    };
  }


  handleAddressChange = (e) => {
    this.setState({ adresse: e, address: e });

    let recentSuggestionsFilter = this.state.recentSuggestions.filter(
      ({ adresse }) => {
        if (
          adresse
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim()
            .replace(/ /g, "-")
            .includes(
              e
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .trim()
                .replace(/ /g, "-")
            )
        ) {
          return true;
        } else {
          return false;
        }
      }
    );
    if (recentSuggestionsFilter.length === 0) {
      this.setState({
        displayRecentSuggestions: false,
        activateGMAPS: true,
      });
    } else {
      this.setState({ recentSuggestions: recentSuggestionsFilter });
    }
  };

  postHandleSelect = (recherche) => {
    this.setState({
      lat: recherche.lat,
      lng: recherche.lng,
      zoom: recherche.zoom,
      speed: recherche.speed,
      address: recherche.adresse,
      commune: recherche.commune,
      province: recherche.province,
      region: recherche.region,
      coordinates: { lat: recherche.lat, lng: recherche.lng },
      zoomEndFromMarker: true,
    });
    this.setState({ handle_recherche: true });


    this.props.setCurrentAddress({
      data: {
        address: recherche.adresse,
        ville: "",
      },
    });

    // if (recherche.zoom > 14) {
    this.handleRechercheLP(recherche);
    // } else {
    //   this.setState({ handle_recherche: false });
    // }
  };

  handleRechercheLP = async (recherche) => {
    this.props.setActiveStep({ data: 0 });

    if (this.props.link) {
      let new_params = new URLSearchParams("");
      new_params.set(
        "adresse",
        recherche && recherche.adresse
          ? recherche.adresse
          : this.state.address
            ? this.state.address
            : ""
      );
      new_params.set(
        "lat",
        recherche && recherche.lat
          ? recherche.lat
          : this.state.lat
            ? this.state.lat
            : ""
      );
      new_params.set(
        "lng",
        recherche && recherche.lng
          ? recherche.lng
          : this.state.lng
            ? this.state.lng
            : ""
      );
      new_params.set(
        "zoom",
        recherche && recherche.zoom
          ? recherche.zoom
          : this.state.zoom
            ? this.state.zoom
            : ""
      );
      new_params.set(
        "speed",
        recherche && recherche.speed
          ? recherche.speed
          : this.state.speed
            ? this.state.speed
            : ""
      );
      new_params.set("first", true)
      window.location.href = `/${this.props.lang}/${this.props.link}?${new_params.toString()}`;
    }
    if (this.state.actif == "estimer") {

      let new_params = new URLSearchParams("");


      new_params.set(
        "adresse",
        recherche && recherche.adresse
          ? recherche.adresse
          : this.state.address
            ? this.state.address
            : ""
      );
      new_params.set(
        "lat",
        recherche && recherche.lat
          ? recherche.lat
          : this.state.lat
            ? this.state.lat
            : ""
      );
      new_params.set(
        "lng",
        recherche && recherche.lng
          ? recherche.lng
          : this.state.lng
            ? this.state.lng
            : ""
      );
      new_params.set(
        "zoom",
        recherche && recherche.zoom
          ? recherche.zoom
          : this.state.zoom
            ? this.state.zoom
            : ""
      );
      new_params.set(
        "speed",
        recherche && recherche.speed
          ? recherche.speed
          : this.state.speed
            ? this.state.speed
            : ""
      );
      new_params.set("first", true)
      window.location.href = `/${this.props.lang}/estimation?${new_params.toString()}`;
    } else {
      if (!recherche.lat || !recherche.lng) {
        window.location.href = `/${this.props.lang}/list.htm`;
      } else {
        let new_params = new URLSearchParams("");


        new_params.set(
          "adresse",
          recherche && recherche.adresse
            ? recherche.adresse
            : this.state.address
              ? this.state.address
              : ""
        );
        new_params.set(
          "lat",
          recherche && recherche.lat
            ? recherche.lat
            : this.state.lat
              ? this.state.lat
              : ""
        );
        new_params.set(
          "lng",
          recherche && recherche.lng
            ? recherche.lng
            : this.state.lng
              ? this.state.lng
              : ""
        );
        new_params.set(
          "zoom",
          recherche && recherche.zoom
            ? recherche.zoom
            : this.state.zoom
              ? this.state.zoom
              : ""
        );
        new_params.set(
          "speed",
          recherche && recherche.speed
            ? recherche.speed
            : this.state.speed
              ? this.state.speed
              : ""
        );
        new_params.set("first", true)
        if (recherche.commune || recherche.region || recherche.province) {
          window.location.href = `/${this.props.lang}/list.htm${recherche.region
            ? `/${recherche.region
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .trim()
              .replace(/ /g, "-")}`
            : ""
            }${recherche.province
              ? `/${recherche.province
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .trim()
                .replace(/ /g, "-")}`
              : ""
            }${recherche.commune
              ? `/${recherche.commune
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .trim()
                .replace(/ /g, "-")}`
              : ""
            }?${new_params.toString()}`;
        } else {
          getRPCQfromCoords({
            lat: recherche.lat,
            lng: recherche.lng,
          })
            .then((RPCQ) => {
              window.location.href = `/${this.props.lang}/list.htm${RPCQ.region
                ? `/${RPCQ.region
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
                  .trim()
                  .replace(/ /g, "-")}`
                : ""
                }${RPCQ.province
                  ? `/${RPCQ.province
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .trim()
                    .replace(/ /g, "-")}`
                  : ""
                }${RPCQ.commune && recherche.zoom > 12
                  ? `/${RPCQ.commune
                    .toLowerCase()
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .trim()
                    .replace(/ /g, "-")}`
                  : ""
                }?${new_params.toString()}`;
            })
            .catch((err) => {
              window.location.href = `/${this.props.lang}/list.htm?${new_params.toString()}`;
            });
        }
      }
    }
  };

  render() {
    const { classes } = this.props;
    const { t, lang } = this.props.i18n;

    return (
      <div
        className={`${styles.search__bar__container} ${styles.search_bar__mobile__container} ${this.props.agenceImmo ? styles.trouvezagenceContainer : null} search-bar-mobile--container`}
      >
        {this.props.display_top_section ? (
          <div className={styles.search__bar__select__container}>
            <div
              className={styles.search__bar__select__inner}
              onClick={() => {

                this.setState({ actif: "estimer" });
              }}
            >
              <SelectItem
                content={t("J'estime mon bien")}
                position={"left"}
                actif={this.state.actif == "estimer"}
              />
            </div>
            <div
              className={styles.search__bar__select__inner}
              onClick={() => {

                this.setState({ actif: "acheter" });
              }}
            >
              <SelectItem
                content={t("J'achète ou je loue")}
                position={"right"}
                actif={this.state.actif == "acheter"}
              />
            </div>
          </div>
        ) : null}
        <div className={`${styles.search__bar__inner} ${this.props.agenceImmo ? styles.searchBarAgence : ""}`}>
          {<p className={`${styles.search__bar__title}`}>
            {this.props.title
              ? t(this.props.title)
              : this.state.actif == "estimer"
                ? t(
                  "Tapez l’adresse de votre appartement ou maison, on vous donne son prix"
                )
                : t(
                  "Cherchez plus simplement votre nouvel appartement ou maison"
                )}
          </p>}

          <div className={`${styles.search__container} ${this.props.agenceImmo ? styles.search_con_agenceLp : null}`}>
            <div className={`${styles.search__inner} ${this.props.agenceImmo ? styles.inputActionsTrouvezAgence : null} `}>
              {this.props.agenceImmo ?
                <div className={styles.inputcontainer}>
                  <PlacesAutocomplete
                    enableDefaultSearchList={true}
                    placeholder={this.props.placeholder}
                    postHandleSelect={
                      this.props.customHandleRecherche
                        ? this.props.customHandleRecherche
                        : this.postHandleSelect
                    }
                    page="landing-page"
                    hide_icon={true}
                    t={t}
                    showSearchIcon={true}
                  />
                </div> :
                <PlacesAutocomplete
                  enableDefaultSearchList={this.state.actif == "estimer" ? false : true}
                  placeholder={this.props.placeholder}
                  postHandleSelect={
                    this.props.customHandleRecherche
                      ? this.props.customHandleRecherche
                      : this.postHandleSelect
                  }
                  page="landing-page"
                  hide_icon={true}
                  t={t}
                  showSearchIcon={true} />}
              <div
                className={`${styles.btn__lp__container}  ${styles.btn_lp_mobile__container} ${this.props.agenceImmo ? styles.searchBtnDiv : ""}`}
              >
                <div
                  className={`${styles.btn__lp__inner} btn-lp-mobile--inner ${this.props.agenceImmo ? styles.searchBtnDivChild : ""}`}
                >
                  <a
                    className={styles.btn__link__container}
                    href={`/${lang}/agence-immobiliere-maroc/recherche`}
                    onClick={(e) => {
                      void 0;
                      e.preventDefault();
                    }}
                  >

                    {!this.state.handle_recherche ? (
                      <button
                        className={`${gs.button} ${gs.btn__primary} ${styles.btn__search_bar__lp} ${this.props.agenceImmo ? styles.searchBtn : ""}`}
                        onClick={() => {
                          this.setState({ handle_recherche: true });
                          if (this.props.customHandleRecherche) {
                            this.props.customHandleRecherche({
                              adresse: this.state.adresse,
                              lat: this.state.lat,
                              lng: this.state.lng,
                              commune: this.state.commune,
                              province: this.state.province,
                              region: this.state.region,
                              zoom: this.state.zoom,
                              speed: this.state.speed,
                            });
                          } else {
                            this.handleRechercheLP({
                              adresse: this.state.adresse,
                              lat: this.state.lat,
                              lng: this.state.lng,
                              commune: this.state.commune,
                              province: this.state.province,
                              region: this.state.region,
                              zoom: this.state.zoom,
                              speed: this.state.speed,
                            });
                          }
                        }}
                      >
                        <div className={styles.btn__content}>
                          {this.props.button_text
                            ? t(this.props.button_text)
                            : this.state.actif == "estimer"
                              ? t("J'estime")
                              : this.props.agenceImmo ? t("Rechercher") : t("Je cherche")}
                        </div>
                      </button>
                    ) : (
                      <button
                        className={`${gs.button} ${gs.btn__primary} ${styles.btn__search_bar__lp}`}
                      >
                        <div className={styles.btn__content}>
                          <i className="fas fa-circle-notch fa-spin"></i>
                        </div>
                      </button>
                    )}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    );
  }
}
const mapStateToProps = (state) => {
  const user = state.auth.user;

  return {
    user: user,
  };
};

export default connect(
  mapStateToProps)(withRouter(withTranslation(LPSearchBar, "LPSearchBar")));
